module.exports = "<div class=\"app-pix-payment-key\">\n\t<app-main-title title=\"Transferir\" subtitle=\"Busque por um novo favorecido ou selecione um já cadastrado\"></app-main-title>\n\t<app-current-balance></app-current-balance>\n\t<app-pix-home-menu [selectedPixMenu]=\"pixMenu.PAGAMENTO\"></app-pix-home-menu>\n\t<app-pix-payment-key-favored-list></app-pix-payment-key-favored-list>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/payment-key.component.html
// module id = ../../../../../src/app/master/pix/payment-key/payment-key.component.html
// module chunks = main